// extracted by mini-css-extract-plugin
export var side_bar_wrapper = "styles-module--side_bar_wrapper--_aoaE";